import React from 'react';
import { ListItemSecondaryAction } from '@material-ui/core';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import { FasTimes, FasPencilAlt } from 'assets/icons';
import { RenderElement } from './RenderElement';

const { List, ListSubHeader } = molecules;
const { Typography, IconButton, Tooltip } = atoms;

export const RenderEditable = ({
  state,
  title,
  setState,
  children,
  subHeaderItems,
  toolbarItems,
  editable,
  editDisabled
}) => (
  <List
    className={state && 'shadow-sm'}
    subheader={(
      <ListSubHeader flex className={editable ? 'editable' : ''}>
        <Typography data-id={`title${title.split(' ')[0]}`} inline primary component="div">
          {title}
          {subHeaderItems}
        </Typography>
        <RenderElement access={editable}>
          <ListItemSecondaryAction style={{ display: 'flex', whiteSpace: 'nowrap' }}>
            {toolbarItems}
            <Tooltip tooltipplacementbottom="true" title={`${!state ? 'Edit' : 'Close'} ${title}`}>
              <IconButton
                aria-label={`Edit ${title}`}
                color="inherit"
                data-id={`edit${title.split(' ')[0].toLowerCase()}`}
                disabled={editDisabled}
                className={`${editDisabled ? 'btn disable':  ''}`}
                onClick={() => setState(!state)}
              >
                <RenderElement access={state}>
                  <Typography link icon>
                    <FasTimes data-id={`close${title.split(' ')[0].toLowerCase()}`}  title={`Close ${title}`} />
                  </Typography>
                </RenderElement>
                <RenderElement access={!state}>
                  <Typography  link icon>
                    <FasPencilAlt data-id={`save${title.split(' ')[0].toLowerCase()}`}/>
                  </Typography>
                </RenderElement>
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </RenderElement>
      </ListSubHeader>
)}
  >
    <div className={editable ? 'card-action-area__highlighted' : ''}>
      {children}
    </div>
  </List>
);
